export function getAssetLabel(asset) {
  const name = asset?.name != null ? String(asset.name).trim() : "";
  const category = asset?.category != null ? String(asset.category).trim() : "";
  if (!name && !category) return "—";
  if (name && category) return `${name} (${category})`;
  return name || category;
}

